import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Select,
    Modal,
    Checkbox,
    Row,
    Col
} from "antd";
import Button from "antd-button-color";

import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { addUserRole, getRole } from "./service";
// import { getTerritory } from "./../../service";

const { Option } = Select;
const { confirm } = Modal;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 16 },
        lg: { span: 14 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};

function success() {
    let secondsToGo = 3;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'แก้ไขข้อมูล เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}
function error(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}

const Editform = (props) => {
    const [form, setFrom] = Form.useForm();

    const [load, setLoad] = useState(true)

    const [id, setId] = useState()
    const [URID, setURID] = useState()
    const [email, setEmail] = useState()
    const [pass, setPass] = useState()

    const [role_select, setRole_select] = useState()
    const [dataRole, setDataRole] = useState([])

    useEffect(() => {
        // console.log("mount it props!", props.userDetail);
        setId(props.userDetail.id)
        setURID(props.userDetail.URID)
        setEmail(props.userDetail.email)

        function setLoadEffect() {
            setLoad(false)
        }
        function getRegionDetail() {
            getData();
        }
        function getData() {
            getRole().then(res => {
                if (res && res.status === 200) {
                    setDataRole(res.data)
                    setLoadEffect()
                }
            })
        }
        getRegionDetail();
    }, [props]);


    const selectRole = (e, name) => {
        setRole_select(e)
    }

    const optionRole = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectRole}
        >
            {
                dataRole.map((data, index) => {
                    // console.log("dataRegion", dataRegion)
                    return (
                        <Option key={index} value={data.URID} rolename={data.role_desc}>{data.role_desc}</Option>
                    );
                })
            }
        </Select>
    )

    const dd = () => {
        console.log("setRegion_select", dataRole)
    }
    const onFinish = (values) => {
        // console.log("Received values of form: ", values);
        const formData = new FormData();

        formData.append('state', 'update');
        formData.append('id', id);
        formData.append('URID', values.role_desc);
        formData.append('email', email);
        if (values.pass) {
            formData.append('password', values.pass);
        }

        addUserRole(formData).then(res => {
            // console.log("res===", res)
            if (res && res.status === 200) {
                form.resetFields();
                success()
            } else {
                error(res)
            }
        })
    };

    if (load) {
        return (
            <div>
                loading
            </div>
        );
    } else {
        return (
            <div >
                {/* <div onClick={dd}>dd</div> */}
                <Form
                    {...formItemLayout}
                    form={form}
                    name="editStaff"
                    id="editStaff"
                    onFinish={onFinish}
                    initialValues={{
                        email: email,
                        role_desc: URID
                    }}
                    scrollToFirstError
                >
                    <Form.Item
                        name="email"
                        label="ชื่อผู้ใช้งาน(BO)"
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: "กรุณาระบุ ชื่อกลุ่มผู้ใช้งาน!",
                    //     }
                    // ]}
                    >
                        {/* <Input disabled={userLevel == 99 ? false:true} /> */}
                        <Input disabled={true} />
                    </Form.Item>
                    <Form.Item
                        name="pass"
                        label="รหัสผ่าน"
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: "กรุณาระบุ ชื่อกลุ่มผู้ใช้งาน!",
                    //     }
                    // ]}
                    >
                        {/* <Input disabled={userLevel == 99 ? false:true} /> */}
                        <Input disabled={false} placeholder="หากไม่แก้ไข จะใช้รหัสผ่านเดิม" />
                    </Form.Item>
                    <Form.Item
                        name="role_desc"
                        label="ชื่อกลุ่มผู้ใช้งาน"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาเลือก พื้นที่รับผิดชอบ!",
                            }
                        ]}
                    >
                        {optionRole}
                    </Form.Item>

                    <div style={{ paddingBottom: '10%' }}>
                        {/* <Button type="warning" onClick={resetPass} style={{ float: 'left' }}>
                            รีเซ็ตรหัสผ่าน
                        </Button> */}
                        <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                            แก้ไขข้อมูล
                        </Button>
                    </div >
                </Form>
            </div >
        );
    }

};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default Editform